import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-14" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-15" data-mp="pj6c83lngiqh">
        <span className="block text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-16" data-mp="avd0itzoq0d6">
          Dziś w pakiecie
        </span>
        <h2 className="mt-5 text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-17" data-mp="fsliatgx82dw">
          5 Ekskluzywnych BONUSÓW
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-18" data-mp="5wrwejhbawjg">
          O wartości{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-19" data-mp="3o2ekzpcku500">268 zł</span> —
          dostępne dziś w cenie zestawu,{' '}
          <span className="font-bold text-brand" data-id="element-20" data-mp="3t180tofc683c">bez dodatkowych kosztów</span>.
        </p>

        <ol className="mt-9 space-y-4" data-id="element-21" data-mp="1martlmorw830">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-22" data-mp="1r8a5nly373f8" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-23" data-mp="3dfv999yxhxf1">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-28 w-24 shrink-0 object-contain sm:h-32 sm:w-28" data-id="element-24" data-mp="3n4muz0deblhi" />
              <div data-id="element-25" data-mp="2zhf1dfpby0vb">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-26" data-mp="2ugr1e4j4i9oy">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-ink/70" data-id="element-27" data-mp="38h1r348p5i8j">
                  {bonus.text}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-ink/50" data-id="element-28" data-mp="33ja1igviy87i">
                  {bonus.detail}
                </p>
                <p className="mt-2 text-[11px] font-bold" data-id="element-29" data-mp="iqygo8nkweyp">
                  <span className="text-amber-700 line-through" data-id="element-30" data-mp="iqf12ylei2nu">
                    wartość {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-31" data-mp="3hhzk5brpzzar">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}